import React from 'react'
import { CreateStarChartHeaderBanner, CreateStarChartHeaderBox, CreateStarChartHeaderIcon, CreateStarChartHeaderText, CreateStarChartHeaderWrapper, StarChartLabel, StarChartSaveButton } from './CreateStarChartHeaderPresentation.style'
import { images } from '../../../../constants'
import { Column, Input } from '../../../../assets/style/General.style'
import { CreateStarChartHeaderPresentationProps } from '../../types/types'

const CreateStarChartHeaderPresentation: React.FC<CreateStarChartHeaderPresentationProps> = ({
    starChartName, 
    setStarChartName
}) => {

  return (
    <CreateStarChartHeaderWrapper>

        <CreateStarChartHeaderBanner>

            <CreateStarChartHeaderText>Star Chart</CreateStarChartHeaderText>

            <CreateStarChartHeaderIcon src={images.StarchartIcon} alt="gradegy" />

        </CreateStarChartHeaderBanner>

        <CreateStarChartHeaderBox>

            <Column Direction="column" alignment={''} width={'fit-content'} minWidth={''} style={{  flex: "inherit"}}>

                <StarChartLabel htmlFor="starChartName">Name</StarChartLabel>

                <Input
                    type="text"
                    id="starChartName"
                    name="starChartName"
                    value={starChartName}
                    placeholder='Star Chart Name'
                    onChange={(e) => { setStarChartName!(e.target.value) } } 
                    Width={''} Height={''} FontFamily={''} Size={''} Weight={''}  SpacingLR={'10px'}   
                    style={{textAlign:"left"}}             
                    />

            </Column>

            <StarChartSaveButton
                spaceLeft="25px"
                onClick={()=>{}}
                style={{ borderRadius: 5, fontSize: 13 }}>
                Save
            </StarChartSaveButton>

        </CreateStarChartHeaderBox>

    </CreateStarChartHeaderWrapper>
  )
}

export default CreateStarChartHeaderPresentation

